import { typedAction } from 'store/modules/base';

export interface State {
  id: string;
  codigoExterno: string;
  codigoInstrumento: string;
}

export const initialState: State = {
  id: '',
  codigoExterno: '',
  codigoInstrumento: '',
};

export const updateId = (emissorId: string) => {
  return typedAction('notaComercial/emissor/UPDATE_ID', emissorId);
};

export const updateCodigoExterno = (codigoExterno: string) => {
  return typedAction('notaComercial/emissor/UPDATE_CODIGO', codigoExterno);
};

export const updateCodigoInstrumento = (codigoInstrumento: string) => {
  return typedAction('notaComercial/emissor/UPDATE_CODIGO_INSTRUMENTO', codigoInstrumento);
};

export const resetEmissor = () => {
  return typedAction('notaComercial/emissor/RESET');
};

export type EmissorAction = ReturnType<typeof updateId | typeof updateCodigoExterno | typeof resetEmissor | typeof updateCodigoInstrumento>;
